export default __webpack_public_path__ + "static/media/wTop_1_c4.777297bf.jpeg";